import React from 'react';
import styles from './RiskDashboardFilter.module.scss';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import PropTypes from 'prop-types';
import { SelectBox, TextBox } from 'devextreme-react';
import { systemAckedTypes } from '../../util/constants';
import { isEmpty } from '../../util/functions';

const styleAttributes = {
  class: styles.inputMobile
};
class RiskDashboardFilter extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      mpid: '',
      systemAcked: null
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch () {
    this.handleSubmit('search');
  }

  handleSubmit (type) {
    let queryParam = this.state;
    this.props.search(queryParam, type);
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.handleSubmit('search');
    };
  }

  render () {
    return (
      <div id='riskDashboardFilter' className={styles.container}>
        <div className={styles.formContainer}>

          <div className={styles.riskFilterGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'mpidKey'}>
              <Label title='MPID' />
              <TextBox
                name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
                valueChangeEvent='keyup'
                inputAttr={styleAttributes}
                onValueChanged={(e) => this.handleChange(e, 'mpid')} />

            </div>
            <div key={'systemAckedKey'}>
              <Label title='Resolved' />
              <SelectBox id={'systemAcked'}
                dataSource={systemAckedTypes}
                showClearButton
                inputAttr={styleAttributes}
                placeholder={'Resolved'}
                value={this.state['systemAcked']}
                displayExpr='value'
                valueExpr='id'
                name={'systemAcked'}
                onValueChanged={(e) => this.handleChange(e, 'systemAcked')} />
            </div>
            <div id='applyButtonDiv' className={styles.applyButton}> <Button title='Apply' onClick={this.handleSearch} size='extraSmall' /></div>

          </div>

        </div>
      </div>
    );
  }
}
export default RiskDashboardFilter;

RiskDashboardFilter.propTypes = {
  search: PropTypes.func
};
